import gamingTool from '../components/gamingTool';

export default {
    init() {
        // JavaScript to be fired on the home page

        const gameContainer = $('#game-page');
        new gamingTool(gameContainer);
        
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/gaming.js